import React from 'react'
import { Card, CardBody, CardHeader, Input, Modal } from 'reactstrap';

interface STSAdjustmentPopupType {
    state: boolean,
    setState: any,
    toggle: any,
    event: any,
    target: string,
}

const STSAdjustmentPopup = ({
    state,
    setState,
    toggle,
    event,
    target,
}: STSAdjustmentPopupType) => {
    return (
        <Modal
            isOpen={state}
            toggle={() => {
                toggle();
            }}
            backdrop={"static"}
            id={target}
            size='xl'
        >
            <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                    Select applicable STS Adjustment events
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                        setState(false);
                    }}
                    aria-label="Close"
                />
            </div>
            <div className="modal-body">
                <Card className='mb-3'>
                    <CardHeader>
                        <h5>Voyage Pre STS Operation</h5>
                    </CardHeader>
                    <CardBody>
                        <div className="table-responsive mb-3">
                            <table className="table mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Applicable</th>
                                        <th>Reporting event</th>
                                        <th>Distance(nm)</th>
                                        <th>Time(hr)</th>
                                        <th>FC</th>
                                        <th>FC<sub>(elec + boiler + other)</sub></th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Input
                                                type='checkbox'
                                                id={`sts_adjustment`}
                                                name={`adjustment.sts_adjustment`}
                                            />
                                        </td>
                                        <td>Noon</td>
                                        <td>500</td>
                                        <td>60</td>
                                        <td>12</td>
                                        <td>10</td>
                                        <td>
                                            <Input
                                                type='textarea'
                                                id={`sts_adjustment_remark`}
                                                name={`adjustment.sts_adjustment_remark`}
                                                className='form-control'
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Input
                                                type='checkbox'
                                                id={`sts_adjustment`}
                                                name={`adjustment.sts_adjustment`}
                                            />
                                        </td>
                                        <td>Piracy</td>
                                        <td>500</td>
                                        <td>60</td>
                                        <td>12</td>
                                        <td>10</td>
                                        <td>
                                            <Input
                                                type='textarea'
                                                id={`sts_adjustment_remark`}
                                                name={`adjustment.sts_adjustment_remark`}
                                                className='form-control'
                                                value={'Already considered in CII Adjustment'}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={2}>Total</th>
                                        <td>1000</td>
                                        <td>120</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </CardBody>
                </Card>
                <Card className='mb-3'>
                    <CardHeader>
                        <h5>STS Operation</h5>
                    </CardHeader>
                    <CardBody>
                        <div className="table-responsive mb-3">
                            <table className="table mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Applicable</th>
                                        <th>Reporting event</th>
                                        <th>Distance(nm)</th>
                                        <th>Time(hr)</th>
                                        <th>FC</th>
                                        <th>FC<sub>(elec + boiler + other)</sub></th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Input
                                                type='checkbox'
                                                id={`sts_adjustment`}
                                                name={`adjustment.sts_adjustment`}
                                                defaultChecked={true}
                                            />
                                        </td>
                                        <td>Noon</td>
                                        <td>500</td>
                                        <td>60</td>
                                        <td>12</td>
                                        <td>10</td>
                                        <td>
                                            <Input
                                                type='textarea'
                                                id={`sts_adjustment_remark`}
                                                name={`adjustment.sts_adjustment_remark`}
                                                className='form-control'
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Input
                                                type='checkbox'
                                                id={`sts_adjustment`}
                                                name={`adjustment.sts_adjustment`}
                                            />
                                        </td>
                                        <td>Piracy</td>
                                        <td>500</td>
                                        <td>60</td>
                                        <td>12</td>
                                        <td>10</td>
                                        <td>
                                            <Input
                                                type='textarea'
                                                id={`sts_adjustment_remark`}
                                                name={`adjustment.sts_adjustment_remark`}
                                                className='form-control'
                                                value={'Already considered in CII Adjustment'}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={2}>Total</th>
                                        <td>1000</td>
                                        <td>120</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </CardBody>
                </Card>
                <Card>
                    <CardHeader>
                        <h5>Voyage Post STS Operation</h5>
                    </CardHeader>
                    <CardBody>
                        <div className="table-responsive mb-3">
                            <table className="table mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Applicable</th>
                                        <th>Reporting event</th>
                                        <th>Distance(nm)</th>
                                        <th>Time(hr)</th>
                                        <th>FC</th>
                                        <th>FC<sub>(elec + boiler + other)</sub></th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Input
                                                type='checkbox'
                                                id={`sts_adjustment`}
                                                name={`adjustment.sts_adjustment`}
                                            />
                                        </td>
                                        <td>Noon</td>
                                        <td>500</td>
                                        <td>60</td>
                                        <td>12</td>
                                        <td>10</td>
                                        <td>
                                            <Input
                                                type='textarea'
                                                id={`sts_adjustment_remark`}
                                                name={`adjustment.sts_adjustment_remark`}
                                                className='form-control'
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Input
                                                type='checkbox'
                                                id={`sts_adjustment`}
                                                name={`adjustment.sts_adjustment`}
                                            />
                                        </td>
                                        <td>Piracy</td>
                                        <td>500</td>
                                        <td>60</td>
                                        <td>12</td>
                                        <td>10</td>
                                        <td>
                                            <Input
                                                type='textarea'
                                                id={`sts_adjustment_remark`}
                                                name={`adjustment.sts_adjustment_remark`}
                                                className='form-control'
                                                value={'Already considered in CII Adjustment'}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={2}>Total</th>
                                        <td>1000</td>
                                        <td>120</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </Modal>
    )
}

export default STSAdjustmentPopup